// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayExtra";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
}
.editProfile_form__taJsX {
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  margin-bottom: 100px;
}
.editProfile_form__taJsX input {
  width: 100%;
}

.editProfile_changePicture__COuh7 {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  grid-gap: 15px;
}
.editProfile_changePicture__COuh7 img {
  width: 200px;
  height: 200px;
}
.editProfile_changePicture__COuh7 p {
  font-family: GteDisplayBold;
  font-size: 16px;
  color: #C2C2C2;
}

.editProfile_body__7pnBk {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  grid-gap: 15px;
  width: 100%;
}
.editProfile_body__7pnBk h4 {
  font-weight: 400;
  line-height: 120%;
  max-width: 300px;
  width: 100%;
}

.editProfile_loadImageBody__n862O {
  position: relative;
}
.editProfile_loadImageBody__n862O input {
  position: absolute;
  opacity: 0;
  visibility: hidden;
}
.editProfile_loadImageBody__n862O input:focus + span {
  box-shadow: 0 0 2px 2px #fff;
}

.editProfile_choiceFileModule__nyvna {
  display: inline-block;
  cursor: pointer;
  border-radius: 10px;
  background-color: transparent;
  box-sizing: border-box;
}
.editProfile_choiceFileModule__nyvna img {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/pages/editProfile/editProfile.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,kBAAA;EACA,+DAAA;EACA,mBAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;AAAF;AACE;EACE,WAAA;AACJ;;AAGA;EACE,mBAAA;EAKA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAJF;AAJE;EACE,YAAA;EACA,aAAA;AAMJ;AAEE;EACE,2BAAA;EACA,eAAA;EACA,cAAA;AAAJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;AAFF;AAGE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AADJ;;AAMA;EACE,kBAAA;AAHF;AAIE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;AAFJ;AAIE;EACE,4BAAA;AAFJ;;AAMA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AAHF;AAKE;EACE,kBAAA;AAHJ","sourcesContent":["@font-face {\r\n  font-family: \"GteDisplayBold\";\r\n  src: url('../../shared/font/gteestiprodisplay_regular.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayExtra\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayLight\";\r\n  font-style: normal;\r\n  src: url('../../shared/font/gteestiprodisplay_light.otf') format(\"truetype\");\r\n  font-weight: normal;\r\n}\r\n\r\n.form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  grid-gap: 10px;\r\n  margin-bottom: 100px;\r\n  input {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.changePicture {\r\n  margin-bottom: 20px;\r\n  img {\r\n    width: 200px;\r\n    height: 200px;\r\n  }\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  grid-gap: 15px;\r\n\r\n  p {\r\n    font-family: GteDisplayBold;\r\n    font-size: 16px;\r\n    color: #C2C2C2;\r\n  }\r\n}\r\n\r\n\r\n.body {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  flex-direction: column;\r\n  grid-gap: 15px;\r\n  width: 100%;\r\n  h4 {\r\n    font-weight: 400;\r\n    line-height: 120%;\r\n    max-width: 300px;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n\r\n.loadImageBody {\r\n  position: relative;\r\n  input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n  input:focus + span {\r\n    box-shadow: 0 0 2px 2px #fff;\r\n  }\r\n}\r\n\r\n.choiceFileModule {\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  border-radius: 10px;\r\n  background-color: transparent;\r\n  box-sizing: border-box;\r\n\r\n  img {\r\n    border-radius: 50%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `editProfile_form__taJsX`,
	"changePicture": `editProfile_changePicture__COuh7`,
	"body": `editProfile_body__7pnBk`,
	"loadImageBody": `editProfile_loadImageBody__n862O`,
	"choiceFileModule": `editProfile_choiceFileModule__nyvna`
};
export default ___CSS_LOADER_EXPORT___;
